import { useContext } from 'react'
import { CustomerContext } from '@/contexts'

export const useCustomer = () => useContext(CustomerContext)
